import(/* webpackMode: "eager" */ "/Users/poojaagrawal/Projects/itellisecure/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/poojaagrawal/Projects/itellisecure/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/poojaagrawal/Projects/itellisecure/src/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/poojaagrawal/Projects/itellisecure/src/components/ui/AnimatedSection.tsx");
